import { countries } from "../../../data/countries";

export const countryCodeToName = (code: string) => {
  return (
    countries.find(
      ({ value }) => value.split("-")[1].toLowerCase() === code?.toLowerCase()
    )?.label || code
  );
};
